import { DirectusService } from "../../directus.service";
import { ApiUtils } from "@/modules/api/Api.utils";
import { DirectusArticleInterface } from "../../domain/directus.interface";
import { DirectusArticle } from "../domain/article";
import { fetchWrapper } from "@chatsystem/common/utils";

export class ArticleRepository implements DirectusArticleInterface {
  async getbySlug(slug: string): Promise<DirectusArticle> {
    "use server";
    const query = DirectusService.buildGetArticleBySlugQuery(slug);

    const fetchConfig = ApiUtils.getFetchConfig({});

    const resp = await fetchWrapper(query, fetchConfig);

    const respParsed = await (resp as Response).json();

    let articleToReturn = null;

    // Ugly fix
    // Asking by slug returns all articles, and only the one matching the slug holds translations
    // Right fix would be to make a batter request, TODO when we have too many articles
    // For now we parse them and only retain the one with translations

    if (Array.isArray(respParsed.data)) {
      articleToReturn = respParsed.data.find(
        (article) => article?.translations?.length > 0
      );
    } else {
      articleToReturn = respParsed.data;
    }

    return articleToReturn as DirectusArticle;
  }
}
